// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2jZyL","title":"Header_title__2iZc7","left":"Header_left__3kiTG","clinicName":"Header_clinicName__12ulw"};